export default {
    props: {
        url: {
            type: String,
            default: ''
        }
    },
    watch: {
        // url() {
        //     this.$nextTick(() => {
        //         this.$emit('input', this.$el.contentDocument)
        //     })
            
        // }
    },
    mounted() {},
    template: `<iframe :src="url" frameborder="0" data-role="confirm-frame" class="card" style="width: 100%; min-height: 100%;"></iframe>`
};
